// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { PageRepoService } from '@client/app/services/api/page-repo/page-repo.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'page-details-section-inventory-header',
    standalone: false,
    template: `
        <div class="d-flex align-items-center mb-2">
            <span class="fa-2x fa-fw mr-2 text-link mt-1 fas fa-heading" aria-hidden="true"></span>
            <div>
                <h2 class="font-weight-300 mb-0" translate>
                    Headers
                </h2>
                @let formattedHeaderCount = data.total | monNumber;
                <span class="text-grey" translate [translate-args]="{headerCount: formattedHeaderCount}">
                    [[headerCount]] found
                </span>
            </div>
        </div>
        <div class="card panel-monsido-card mt-2">
            <div class="card-body">
                <table-container
                        noResultMessage="{{ 'Good job! No issues were found' | translate }}"
                        [collection]="data"
                        (onPageChange)="onPageChange($event)"
                        (onPerPageChange)="onPageSizeChange($event)"
                        [progress]="promise">
                    <table class="table table-hover table-vertial-align">
                        <thead>
                            <tr>
                                <th class="col-4">
                                    <span class="inline-block pl-3" translate>
                                        Header type
                                    </span>
                                </th>
                                <th class="col-44">
                                    <span class="inline-block pr-3" translate>
                                        Text
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let meta of data">
                                <td>
                                    <span class="pl-3 inline-block">
                                        {{meta.key}}
                                    </span>
                                </td>
                                <td>
                                    <span class="pr-3 inline-block">
                                        {{ meta.value }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </table-container>
            </div>
        </div>
    `,
})
export class PageDetailsSectionInventoryHeaderComponent extends BaseContainerComponentController implements OnInit {
    @Input() pageObj: any;

    data: any = [];
    promise: any;
    selected: any = [];

    constructor (private pageRepoService: PageRepoService) {
        super({
            table: true,
        });
        this.getPage = this.getPageMethod;
    }

    ngOnInit () {
        this.pageObj = this.pageObj || {};
        this.data = [];
        this.search = null;
        this.getPageMethod();
    }

    getPageMethod = () => {
        this.selected = [];
        const params: any = {
            type: 'header',
            page_size: this.pageSize,
            page: this.page,
            search: this.search,
        };

        this.promise = this.pageRepoService.getMetadata(this.pageObj.id, params).then((data) => {
            this.data = data;
        });
    };

    trackByIndex (index: number): number {
        return index;
    }
}
